import { ISessionService } from '../../services/session';
import { INavigationService } from '../../services/navigationService';
import ITenantHandlerService from '../../services/tenantHandler/ITenantHandlerService';

type NavigationWithSessionParams = {
  navigationService: INavigationService;
  sessionService: ISessionService;
  tenantHandlerService: ITenantHandlerService;
};

export default class UseLoggedInRules {
  private _navigation: INavigationService;
  private _sessionService: ISessionService;
  private _tenantHandlerService: ITenantHandlerService;

  constructor({
    navigationService,
    sessionService,
    tenantHandlerService
  }: NavigationWithSessionParams) {
    this._navigation = navigationService;
    this._sessionService = sessionService;
    this._tenantHandlerService = tenantHandlerService;
  }

  public init = async (): Promise<void> => {
    const isLoggedIn = this._sessionService.isLoggedIn();
    if (!isLoggedIn) {
      return;
    }

    const loggedInPath = this._navigation?.createHref?.({
      pathname: '/loggedin'
    });

    const currentPath = window.location.pathname;

    if (currentPath === loggedInPath) {
      await this._sessionService.refresh({
        tenantsIdMap: this._tenantHandlerService?.getTenantIdsMap()
      });
    }
  };
}
